import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiCall } from "../helper/axios";
// ======================================================
// ✅ ASYNC THUNK
// ======================================================
export const triggerRefresh = createAsyncThunk("refresh/triggerRefresh", async (payload, { getState, rejectWithValue }) => {
    try {
        const { auth } = getState();
        const token = auth?.token;
        const body = {};
        if (payload.clientId !== undefined)
            body.clientId = payload.clientId;
        if (payload.dateRange)
            body.dateRange = payload.dateRange;
        if (payload.connectionId)
            body.connectionId = payload.connectionId;
        if (payload.platform)
            body.platform = payload.platform;
        if (payload.clientIds)
            body.clientIds = payload.clientIds;
        if (payload.submodule)
            body.submodule = payload.submodule;
        if (payload.networks?.length)
            body.networks = payload.networks;
        const headers = { Authorization: token || "" };
        if (payload.moduleKey)
            headers["x-module-key"] = payload.moduleKey;
        const response = await ApiCall("POST", "/api/refresh", body, headers);
        if (response && !response.isAxiosError && response.data?.success !== false && "data" in response && response?.data) {
            return response.data;
        }
        else {
            const errorMessage = response?.response?.data?.message ||
                response?.data?.message ||
                response?.message ||
                "Failed to trigger refresh";
            return rejectWithValue(errorMessage);
        }
    }
    catch (error) {
        console.error("Refresh API Error:", error);
        return rejectWithValue(error?.response?.data?.message ||
            error.message ||
            "Something went wrong while refreshing");
    }
});
// ======================================================
// ✅ CHECK REFRESH STATUS
// ======================================================
export const checkRefreshStatus = createAsyncThunk("refresh/checkStatus", async ({ moduleKey }, { getState, rejectWithValue }) => {
    try {
        const { auth } = getState();
        const token = auth?.token;
        const response = await ApiCall("GET", `/api/refresh-status/${moduleKey}`, undefined, { Authorization: token || "" });
        if (response && "data" in response && response?.data) {
            return response.data.data; // { isSyncing: boolean }
        }
        else {
            return rejectWithValue("Failed to fetch refresh status");
        }
    }
    catch (error) {
        console.error("Check Status API Error:", error);
        return rejectWithValue(error?.response?.data?.message ||
            error.message ||
            "Something went wrong while checking status");
    }
});
// ======================================================
// ✅ INITIAL STATE
// ======================================================
const initialState = {
    loading: false,
    success: false,
    error: null,
    response: null,
    isSyncing: false,
};
// ======================================================
// ✅ SLICE
// ======================================================
const refreshSlice = createSlice({
    name: "refresh",
    initialState,
    reducers: {
        clearRefreshState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
            state.response = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(triggerRefresh.pending, (state) => {
            state.loading = true;
            state.success = false;
            state.error = null;
        })
            .addCase(triggerRefresh.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.success;
            state.response = action.payload;
            state.isSyncing = true;
        })
            .addCase(triggerRefresh.rejected, (state, action) => {
            state.loading = false;
            state.success = false;
            state.error = action.payload || "Refresh failed";
        })
            // Check Status
            .addCase(checkRefreshStatus.fulfilled, (state, action) => {
            state.isSyncing = action.payload.isSyncing;
        });
    },
});
// ======================================================
// ✅ EXPORTS
// ======================================================
export const { clearRefreshState } = refreshSlice.actions;
export const selectRefreshLoading = (state) => state.refresh.loading;
export const selectRefreshSuccess = (state) => state.refresh.success;
export const selectRefreshError = (state) => state.refresh.error;
export const selectRefreshResponse = (state) => state.refresh.response;
export const selectIsSyncing = (state) => state.refresh.isSyncing;
export default refreshSlice.reducer;
